export enum ASPModule {
    hr = 'hr',
    inventory = 'inventory',
    process = 'process',
    finance = 'finance',
}